import type { ReactElement, ReactNode } from "react";
import type { Person, TaxBreakdown } from "@b2bportal/air-booking-api";
import type { Prices, Product } from "@b2bportal/purchase-api";

export enum SummaryLineType {
  TOTAL = "TOTAL",
  PRODUCT = "PRODUCT",
  CARD_PAYMENT = "CARD_PAYMENT",
  FINTECH = "FINTECH",
  SUB_TOTAL = "SUB_TOTAL",
}

export interface LineItem {
  label: string;
  value: string;
}

export interface ProductLineData {
  price: Prices;
  type: Product;
}

export interface IPriceLineData {
  person: Person;
  baseAmount: Prices;
  taxesAndFees?: Prices;
  products?: ProductLineData[];
  total?: Prices;
}

export interface ISummaryLineData {
  type: SummaryLineType;
  price: Prices;
}

export interface IProductLineItem {
  label: string;
  value: string;
  icon?: ReactElement;
  className?: string;
  type: Product;
}

export interface IPriceLineItem {
  lineTitle?: string;
  baseAmount: LineItem;
  taxesAndFees?: LineItem;
  /**
   * Optional element rendered inline after the taxes & fees label — e.g. an
   * info popover/disclaimer. Only rendered when a taxesAndFees line is present.
   */
  taxesAndFeesTooltip?: ReactNode;
  icon?: ReactElement;
  products?: IProductLineItem[];
  className?: string;
  taxBreakdown?: TaxBreakdown;
}

export interface ISummaryLineItem {
  icon?: ReactElement;
  label: string | ReactElement;
  subtitle?: string;
  value: string | ReactElement;
  type: SummaryLineType;
  className?: string;
}

export interface IFintechLineItem {
  title: string;
  price: string;
}

export interface IFlightExchangeLineItem {
  amount: number;
  currency: string;
  label: string;
}

export interface IFlightExchangeSummaryLineItem
  extends IFlightExchangeLineItem {
  type: SummaryLineType;
}
